
    import __mfReactDefault from "react";
    import * as __mfReactNamespace from "react";
    const __mfReact = __mfReactDefault ?? __mfReactNamespace.default ?? __mfReactNamespace;
    
const __mfCacheGlobalKey = "__mf_module_cache__";
globalThis[__mfCacheGlobalKey] ||= { share: {}, remote: {} };
globalThis[__mfCacheGlobalKey].share ||= {};
globalThis[__mfCacheGlobalKey].remote ||= {};
const __mfModuleCache = globalThis[__mfCacheGlobalKey];

    import { hostInitPromise as __mfHostInitPromise } from "virtual:mf:__mfe_internal__shell__H_A_I__hostAutoInit__H_A_I__.js";
    
    function __mfStartRemoteLoad() {
      
      const pendingKey = "__mf_pending__shared-ui/platform-core/public/locale/zh_HK.js";
      if (!__mfModuleCache.remote[pendingKey]) {
        __mfModuleCache.remote[pendingKey] = __mfHostInitPromise
          .then((runtime) => {
            
            return runtime.loadRemote("shared-ui/platform-core/public/locale/zh_HK.js");
          })
          .then((mod) => {
            __mfModuleCache.remote["shared-ui/platform-core/public/locale/zh_HK.js"] = mod;
            delete __mfModuleCache.remote[pendingKey];
            return mod;
          })
          .catch((error) => {
            delete __mfModuleCache.remote[pendingKey];
            throw error;
          });
      }
      return __mfModuleCache.remote[pendingKey];
    }
    function __mfCreateRemoteProxy(pendingPromise) {
      const listeners = new Set();
      const ensurePending = () => {
        pendingPromise ||= __mfStartRemoteLoad();
        pendingPromise?.finally(() => {
          for (const listener of listeners) listener();
        });
        return pendingPromise;
      };
      const getModule = () => __mfModuleCache.remote["shared-ui/platform-core/public/locale/zh_HK.js"];
      const proxyTarget = function (...args) {
        const [, setVersion] = __mfReact.useState(0);
        __mfReact.useEffect(() => {
          ensurePending();
          const listener = () => setVersion((value) => value + 1);
          listeners.add(listener);
          if (getModule()) listener();
          return () => listeners.delete(listener);
        }, []);
        const mod = getModule();
        const fn = mod && (mod.default ?? mod);
        if (fn !== undefined && fn !== null) {
          return __mfReact.createElement(fn, args[0]);
        }
        return null;
      };
      return new Proxy(proxyTarget, {
        get(_target, prop) {
          if (prop === "__mf_is_remote_proxy") return true;
          if (prop === "__esModule") return true;
          if (prop === "then") return undefined;
          // Allow React's dev-mode console.warn to stringify the proxy without
          // throwing "Cannot convert object to primitive value".
          if (prop === Symbol.toPrimitive || prop === "toString")
            return () => "[MF remote proxy: pending]";
          const mod = getModule();
          if (mod) {
            return prop in mod ? mod[prop] : mod.default?.[prop];
          }
          // When the module is pending and React.lazy() checks for "default",
          // return the proxy function itself so React renders it (returns null)
          // rather than crashing on undefined.
          if (prop === "default") return proxyTarget;
          return undefined;
        },
        has(_target, prop) {
          const mod = getModule();
          if (mod) return prop in mod;
          // Tell React that "default" exists when module is pending so it
          // doesn't warn "lazy: Expected the result of a dynamic import()".
          return prop === "default" || prop === "__esModule" || prop === "__mf_is_remote_proxy";
        },
        ownKeys() {
          const mod = getModule();
          const keys = new Set(mod ? Reflect.ownKeys(mod) : []);
          // Proxy invariant: must include non-configurable target own keys
          for (const k of Reflect.ownKeys(proxyTarget)) {
            const d = Object.getOwnPropertyDescriptor(proxyTarget, k);
            if (d && !d.configurable) keys.add(k);
          }
          return Array.from(keys);
        },
        getOwnPropertyDescriptor(_target, prop) {
          // Proxy invariant: non-configurable target props must be reported accurately
          const targetDesc = Object.getOwnPropertyDescriptor(proxyTarget, prop);
          if (targetDesc && !targetDesc.configurable) return targetDesc;
          const mod = getModule();
          if (!mod) return undefined;
          return Object.getOwnPropertyDescriptor(mod, prop) || {
            configurable: true,
            enumerable: true,
            value: mod[prop],
          };
        },
        apply(target, thisArg, args) {
          return target.apply(thisArg, args);
        }
      });
    }
    let __mfRemotePending;
    let exportModule = __mfModuleCache.remote["shared-ui/platform-core/public/locale/zh_HK.js"]
    if (exportModule === undefined) {
      __mfRemotePending = __mfStartRemoteLoad();
      exportModule = __mfCreateRemoteProxy(__mfRemotePending);
    }
    if (__mfRemotePending) {
  __mfRemotePending = __mfRemotePending.then((mod) => {
    if (mod !== undefined) exportModule = mod;
    return exportModule;
  });
}
export { exportModule as __moduleExports };
export const __mf_remote_pending = __mfRemotePending || Promise.resolve(exportModule);
export default exportModule?.__mf_is_remote_proxy ? exportModule : exportModule?.__esModule ? exportModule.default : exportModule.default ?? exportModule
  